/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'avi-alert-bell';
const componentName = 'avi-alert-bell';
const prefix = `${moduleName}.${componentName}`;

export const alertLabel = `${prefix}.alertLabel`;

export const ENGLISH = {
    [alertLabel]: 'Alerts',
};
